import _slicedToArray from "/Users/janjelschen/apploft/tln/tln_lottonds_backend/apploft_cloud_react_modules/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";

/**
 * Widget.js
 *
 * Copyright (c) apploft. GmbH
 */
import Input from './Input';
import TextArea from './TextArea';
import { typeMatchingProps } from './WidgetTypes';
import { mangle } from './Submission';
import Select from './Select';
import { matching } from './FormatString';
import DatePicker from './DatePicker/DatePicker';

function guessDefaultValue(key, properties) {
  var found = properties[key];

  if (typeof found !== 'object') {
    return undefined;
  }

  var allows = found.allows;

  if (!Array.isArray(allows)) {
    return undefined;
  }

  return allows[0];
}

function shouldHide(_ref, fieldset, watch, properties) {
  var format = _ref.format;

  var _matching = matching(format, 'hiddenif'),
      _matching2 = _slicedToArray(_matching, 2),
      key = _matching2[0],
      value = _matching2[1];

  if (!key) {
    return false;
  }

  var name = mangle(fieldset, key);
  var defaultValue = guessDefaultValue(key, properties);
  var current = watch(name, defaultValue);
  return current === value || current && current.value === value;
}
/**
 * A generic input form widget.
 *
 * @param {*} props
 */


function Widget(_ref2) {
  var name = _ref2.name,
      props = _ref2.props,
      errors = _ref2.errors,
      register = _ref2.register,
      context = _ref2.context,
      control = _ref2.control,
      defaultValue = _ref2.defaultValue,
      strings = _ref2.strings;
  console.assert(register, 'missing register method');

  if (context) {
    var fieldset = context.fieldset,
        properties = context.properties,
        watch = context.watch;

    if (shouldHide(props, fieldset, watch, properties)) {
      return null;
    }
  }

  try {
    var type = typeMatchingProps(props);

    if (type === 'select') {
      return Select({
        name: name,
        props: props,
        errors: errors,
        control: control,
        defaultValue: defaultValue
      });
    }

    if (type === 'textarea') {
      return TextArea({
        name: name,
        props: props,
        errors: errors,
        register: register,
        defaultValue: defaultValue,
        strings: strings
      });
    }

    if (type === 'date') {
      return DatePicker({
        name: name,
        control: control,
        defaultValue: defaultValue,
        strings: strings
      });
    }

    return Input({
      name: name,
      props: props,
      errors: errors,
      register: register,
      type: type,
      defaultValue: defaultValue,
      strings: strings
    });
  } catch (error) {
    if (name !== mangle('payload', 'data')) {
      throw error;
    }

    return Input({
      name: name,
      props: props,
      errors: errors,
      register: register,
      type: 'text',
      defaultValue: defaultValue,
      strings: strings
    });
  }
}

export default Widget;